import { FormControlLabel, FormHelperText, Grid, InputLabel } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { SecondaryButton, SecondaryCheckbox, TextBox } from '../../../Core/FormInput';
import AppContext from '../../../App/AppContext';
import { postEventDocs } from '../../../Core/Service/vmrs-service';

const EventDocumentsDialog = (props) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        eventDocName: '',
        eventDocRequiredInDays: ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (!props.data.isAdd) {
            let temp = props.data.selectedRowData;
            setState((st) => ({
                ...st,
                eventDocID: temp.eventDocID,
                eventDocName: temp.eventDocName,
                eventDocRequiredInDays: temp.eventDocRequiredInDays,
                eventDocChase: temp.eventDocChase === 'Yes' ? true : false,
                eventDocLegal: temp.eventDocLegal === 'Yes' ? true : false
            }));
        }
    }, []);
    const validate = () => {
        let noErrors = true;
        let err = {};

        if (!/[^\s]/.test(state.eventDocName)) {
            err.eventDocName = true;
            noErrors = false;
        }
        let temp = state.eventDocRequiredInDays;
        if (!/[^\s]/.test(temp)) {
            err.eventDocRequiredInDays = true;
            noErrors = false;
        } else if (+temp < 0) {
            err.eventDocRequiredInDaysN = true;
            noErrors = false;
        }
        setErrors(err);
        return noErrors;
    };

    const saveData = async (outData) => {
        if (validate()) {
            let response = await postEventDocs({
                eventDocID: state.eventDocID || null,
                eventDocName: state.eventDocName,
                eventDocRequiredInDays: parseInt(state.eventDocRequiredInDays),
                eventDocChase: state.eventDocChase || false,
                eventDocLegal: state.eventDocLegal || false
            });
            if (response.success) {
                showToast(state.isAdd ? 'Event documents added successfully' : 'Event documents updated successfully');
                props.onClose(true);
            } else {
                showToast(response.message || 'Something went wrong');
            }
        }
        // pullApiData();
    };

    const valueChanged = (ev) => {
        let temp = ev.target;
        setState((st) => ({
            ...st,
            [temp.name]: temp.type === 'checkbox' ? temp.checked : temp.value
        }));
        setErrors({});
    };
    const checkPrevention = (event) => {
        if (/[^0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} className="mandatory-fields">
                    <InputLabel shrink required>
                        Name
                    </InputLabel>
                    <TextBox name="eventDocName" value={state.eventDocName || ''} onChange={valueChanged} />
                    <FormHelperText error>{errors.eventDocName ? 'This field is required' : null}</FormHelperText>
                </Grid>
                <Grid item xs={12} className="mandatory-fields">
                    <InputLabel shrink required>
                        Required In Days
                    </InputLabel>
                    <TextBox name="eventDocRequiredInDays" value={state.eventDocRequiredInDays || ''} onChange={valueChanged} />
                    <FormHelperText error>
                        {errors.eventDocRequiredInDaysN ? 'Negative value is not acceptable' : errors.eventDocRequiredInDays ? 'This field is required' : null}
                    </FormHelperText>
                </Grid>
                <Grid item xs={6}>
                    {/* <SecondaryCheckbox onChange={valueChanged} checked={state.eventDocChase || false} name="eventDocChase" label="Chase Documents?" /> */}
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.eventDocChase || false} name="eventDocChase" onChange={valueChanged} />}
                        label="Chase Documents?"
                    />
                </Grid>
                <Grid item xs={6}>
                    {/* <SecondaryCheckbox onChange={valueChanged} checked={state.eventDocLegal || false} name="eventDocLegal" label="Legal Documents?" /> */}
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.eventDocLegal || false} name="eventDocLegal" onChange={valueChanged} />}
                        label="eventDocLegal"
                    />
                </Grid>
                <Grid item xs={12} className="submit_btn">
                    <SecondaryButton onClick={saveData} fullWidth>
                        {props.data.isAdd ? 'ADD' : 'UPDATE'}
                    </SecondaryButton>
                </Grid>
            </Grid>
        </>
    );
};
export default EventDocumentsDialog;
